import { Button, type ButtonProps, cn, TypographyDetail } from '@seen/ui'
import { forwardRef, type ReactNode } from 'react'

export interface RowBadgeProps extends ButtonProps {
  icon: ReactNode
}

export const RowBadge = forwardRef<HTMLButtonElement, RowBadgeProps>(
  ({ icon, children, className, ...delegated }, ref) => (
    <Button
      variant="status"
      className={cn(
        'max-w-56 items-center justify-start gap-1.5 overflow-hidden',
        className
      )}
      ref={ref}
      {...delegated}
    >
      {icon}
      <TypographyDetail className="mr-px min-w-0 truncate text-left font-normal">
        {children}
      </TypographyDetail>
    </Button>
  )
)
RowBadge.displayName = 'RowBadge'
